import script from "./PgmNoticeDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./PgmNoticeDetail.vue?vue&type=script&setup=true&lang=ts"

import "./PgmNoticeDetail.vue?vue&type=style&index=0&id=17c55c00&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17c55c00"]])

export default __exports__